// extracted by mini-css-extract-plugin
export default {"table":"AdminView_table__O18oR","imgPreview":"AdminView_imgPreview__ZbK3h","pagination":"AdminView_pagination__e0duD","footer":"AdminView_footer__Oo77d"};